export default __webpack_public_path__ + "static/media/element_spec_40.bae9c34b.jpg";